import ProjectSession from "../project-session"
import {ProjectAccess} from "../../../gd/const/project"

export default function canAddProjectUsers(project:ProjectSession) {

    // cant add users to archived projects
    if (gd.const.systemStatus.isClosed(project.systemStatus)) return false

    // because it's public it adds users automatically so we cant add manually!
    if (project.accessModeIsPublic) return false

    // make sure project user exists
    const projectUser = gd.session.projectUsers.findByProjectAndUser(project.id, gd.user.id)
    if (!projectUser) return false

    // verify with projectAccess settings
    switch (projectUser.access) {
        case ProjectAccess.FULL:
            return true
        case ProjectAccess.STANDARD:
            return gd.company.settings.projectAccess.standard.addProjectUsers

        case ProjectAccess.LIMITED:
        case ProjectAccess.CLIENT:
        case ProjectAccess.READ_ONLY:
            return false
        default:
            console.error("canAddProjectUsers error: unknown option")
            return false
    }
}